import React from 'react';
import CallButton from './CallButton';
import ConnectedControls from './ConnectedControls';

const CallControlsContainer = ({
  isCallConnected, rtcStatus, otherParticipant,
  initiateCall, toggleRemoteAudio, isRemoteAudioMuted,
  toggleMute, isMuted, isSpeaking,
  endCall, isCallEnding
}) => {
  return (
    <div className="flex items-center gap-3">
      {!isCallConnected ? (
        <CallButton
          onClick={initiateCall}
          disabled={!otherParticipant || rtcStatus === 'connecting'}
          otherParticipantName={otherParticipant?.name}
          rtcStatus={rtcStatus}
        />
      ) : (
        <ConnectedControls
          toggleRemoteAudio={toggleRemoteAudio}
          isRemoteAudioMuted={isRemoteAudioMuted}
          toggleMute={toggleMute}
          isMuted={isMuted}
          isSpeaking={isSpeaking}
          endCall={endCall}
          isCallEnding={isCallEnding}
        />
      )}
    </div>
  );
};

export default CallControlsContainer;
